import axios from '@/libs/api.request';

export const getMyPreSalePlan = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getMyPreSalePlan',
        data: data,
        method: 'post'
    });
};

export const getPreSalePlan = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getPreSalePlan',
        data: data,
        method: 'post'
    });
};

export const getMyPreSalePlanByDateRange = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getMyPreSalePlanByDateRange',
        data: data,
        method: 'post'
    });
};

export const saveMyPreSalePlan = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/saveMyPreSalePlan',
        data: data,
        method: 'post'
    });
};
export const savePreSalePlan = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/savePreSalePlan',
        data: data,
        method: 'post'
    });
};

export const importPreSalePlan = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/importPreSalePlan',
        data: data,
        method: 'post'
    });
};

export const getWeekConfig = year => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getWeekConfig',
        data: { year },
        method: 'post'
    });
};

export const getWeekConfigYears = years => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getWeekConfigYears',
        data: { years },
        method: 'post'
    });
};

export const getPreSalePlanWeeks = (year, seedFarmUUid) => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getPreSalePlanWeeks',
        data: { year, seedFarmUUid },
        method: 'post'
    });
};

//生成周计划
export const updateWeekPlan = (weeks, year) => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/updateWeekPlan',
        data: { weeks, year },
        method: 'post'
    });
};
export const getPreSalePlanWeekList = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getPreSalePlanWeekList',
        data: data,
        method: 'post'
    });
};

export const getOnePreSalePlan = data => {
    return axios.request({
        url: 'api/preSaleManagement/preSalePlan/getOnePreSalePlan',
        data: data,
        method: 'post'
    });
};